module.exports = __webpack_public_path__ + "img/EducationalScheduleTimeDetails.d70fc61f.svg";